/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlaybackErrorType {
    GENERAL_ERROR = 0,
    LOCATION_ERROR,
    PLAYBACK_ERROR,
    SESSION_ERROR,
}
